import React from 'react';
import { ESRD, PSYCH, REHAB } from '../../../Constants/modelTypes';
import { formatStringAsCurrency } from '../../../Utils/stringUtils';
import ResultValue from '../../Simple/ResultValue';

export default function PricingAmounts(props) {

    if (props.model === PSYCH) {
        return (<>
            <h4>Pricing Amounts</h4>
            <ResultValue label="Federal Amount" value={formatStringAsCurrency(props.result.baseFederalPayment)} />
            <ResultValue label="Teaching Adjustment" value={formatStringAsCurrency(props.result.teachingPayment)} />
            <ResultValue label="Electroconvulsive Therapy Payment" value={formatStringAsCurrency(props.result.ectPayment)} />
            <ResultValue label="Outlier Payment" value={formatStringAsCurrency(props.result.outlierPayment)} />
        </>);
    }

    if (props.model === REHAB) {
        return (<>
            <h4>Pricing Amounts</h4>
            <ResultValue label="Federal Amount" value={formatStringAsCurrency(props.result.federalAdjAmount)} />
            <ResultValue label="Teaching Adjustment Amount" value={formatStringAsCurrency(props.result.teachingAdjAmount)} />
            <ResultValue label="LIP Amount" value={formatStringAsCurrency(props.result.lipAdjAmount)} />
            <ResultValue label="Outlier Payment" value={formatStringAsCurrency(props.result.outlierPayment)} />
        </>);
    }

    if (props.model === ESRD) {
        return (<>
            <h4>Amounts</h4>
            <ResultValue label="TDAPA Payment" value={formatStringAsCurrency(props.result.tdapaPayment)} />
            <ResultValue label="Training Add-On" value={formatStringAsCurrency(props.result.trainingAddOn)} />
            <ResultValue label="Separately Payable Amount" value={formatStringAsCurrency(props.result.separatelyPayableAmount)} />
            <ResultValue label="Network Reduction Fee" value={formatStringAsCurrency(props.result.networkReductionFee)} />
            <ResultValue label="PPS Adjusted Base Rate" value={formatStringAsCurrency(props.result.ppsAdjustedBaseRate)} />
            <ResultValue label="Total Medicare Allowed" value={formatStringAsCurrency(props.result.totalMedicareAllowed)} />
            <ResultValue label="Outlier Payment" value={formatStringAsCurrency(props.result.totalOutlierPayment)} />
        </>);
    }
    
    console.warn('Model unknown:', props.model);
    return null;
}